import { FieldEditorProps } from './FieldEditorProps';
import '../styles/Editors.scoped.scss';

export const ColumnFieldEditor = ({ field, onChange }: FieldEditorProps) => {

    // Keep in sync with app/models/dashboard_field.rb:ALLOWED_TARGET_FIELDS
    const columnOptions = [
        { label: 'Name', value: 'name'},
        { label: 'First Name', value: 'first_name'},
        { label: 'Last Name', value: 'last_name'},
        { label: 'Membership Number', value: 'external_id'},
        { label: 'Email', value: 'email'},
        { label: 'Phone Number', value: 'phone_number'},
        { label: 'Address', value: 'address'},
    ];

    return <div className="field-editor-row">
        <label>Field</label>
        <div className='field-editor-input'>
            <select
                className="source-selector"
                onChange={(e) => onChange({column: e.target.value === "" ? null : e.target.value})}
                value={field?.column || ''}
                >
                <option key={null} value={''}>
                    Select a field
                </option>
                {columnOptions.map(({label, value}) => (
                <option key={value} value={value}>
                {label}
                </option>
                ))}
            </select>
        </div>
    </div>
}